import api from "../../services/api";
import handleError from "../../services/apiErrorHandler";
import { Modal } from "antd";

const permissionMiddleware = store => next => action => {
  if (action.type === "PERMISSION_UPDATE") {
    /** Obtém as permissões do usuário */

    store.dispatch({
      type: "PERMISSION_LOADING"
    });

    api
      .get("/permission/")
      .then(response => {
        const permissions = response.data.permissions;
        const group = response.data.group;
        const explicit_permissions =
          response.data.explicit_permissions === undefined
            ? null
            : response.data.explicit_permissions;
        console.log("PERMISSIONS", permissions);
        store.dispatch({
          type: "PERMISSION_OK",
          permissions,
          explicit_permissions,
          group
        });
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });

        store.dispatch({
          type: "PERMISSION_ERROR"
        });
      });
  }

  next(action);
};

export default permissionMiddleware;



// WEBPACK FOOTER //
// ./src/store/middlewares/permissions.js